'use client'

import Typography from '@mui/material/Typography'
import Image from 'next/image'
import { FC } from 'react'
import handHoldingPhoneMobile from '../../../../public/assets/hand-holding-phone-mobile.jpg'
import appStoreButton from '../../../../public/assets/app-store-button.png'
import googlePlayButton from '../../../../public/assets/google-play-button.png'
import BlankTargetLink from '../../../shared/components/BlankTargetLink'
import GridContainer from '../../../shared/components/GridContainer'
import { useAnalytics } from '../../../shared/context/Analytics'
import useDeviceDetect from '../../../shared/hooks/useDeviceDetect'
import { colors } from '../../../shared/theme/colors'

const AppDownloadSection: FC = () => {
  const { isAndroid, isDesktop } = useDeviceDetect()
  const { track, events } = useAnalytics()

  return (
    <div
      className="md:bg-handHoldingPhone bg-no-repeat bg-center md:bg-top bg-cover py-16 md:py-48"
      data-nosnippet
    >
      <GridContainer>
        <div
          className={`
            col-span-full md:hidden
            mb-6 rounded-[12px] overflow-hidden
          `}
        >
          <div className="relative w-full aspect-[1]">
            <Image
              src={handHoldingPhoneMobile}
              alt="Hand holding a phone showing the Mission Lane app account summary with balance, current bill, and recent transactions"
              priority
              fill
              className="object-[65%_10%]"
            />
          </div>
        </div>
        <div className="col-span-full md:col-span-6 flex flex-col gap-4 md:gap-6">
          <Typography variant="h1" sx={{ color: 'white' }} className="hidden md:block">
            Download the Mission Lane app
          </Typography>
          <Typography variant="p1" sx={{ color: 'white' }} className="hidden md:block">
            Pay bills, check your balance and transactions, and monitor your credit score on the go,
            anytime, anywhere.
          </Typography>
          <Typography
            variant="h2"
            component="h1"
            sx={{ color: colors.Green[900] }}
            className="md:hidden"
          >
            Download the Mission Lane app
          </Typography>
          <Typography variant="p1" sx={{ color: colors.Green[900] }} className="md:hidden">
            Pay bills, check your balance and transactions, and monitor your credit score on the go,
            anytime, anywhere.
          </Typography>
          <div className="flex flex-row gap-6">
            {(isDesktop || !isAndroid) && (
              <BlankTargetLink
                href="https://apps.apple.com/us/app/mission-lane-card/id1228440036"
                data-testid="app-store-button"
                onClick={() =>
                  track?.(events.INTERACTION.ClickCta, { cta: 'Download App - App Store' })
                }
              >
                <Image src={appStoreButton} alt="Mission Lane App Store" width={150} height={45} />
              </BlankTargetLink>
            )}
            {(isDesktop || isAndroid) && (
              <BlankTargetLink
                href="https://play.google.com/store/apps/details?id=com.lcard_app&hl=en_US&gl=US&pli=1"
                data-testid="google-play-button"
                onClick={() =>
                  track?.(events.INTERACTION.ClickCta, { cta: 'Download App - Google Play' })
                }
              >
                <Image
                  src={googlePlayButton}
                  alt="Mission Lane Google Play"
                  width={150}
                  height={45}
                />
              </BlankTargetLink>
            )}
          </div>
        </div>
      </GridContainer>
    </div>
  )
}

export default AppDownloadSection
